/* eslint-disable no-else-return */
/* eslint-disable max-lines */
import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const floatingClientListInit = {
  'document': {
    'data': [],
    'loading': false,
  },
  'lastNames': {
    'data': [],
    'loading': false,
  },
  'names': {
    'data': [],
    'loading': false,
  },
};
const floatingInventoryDropDownListInit = {
  'order': {
    'data': [],
    'loading': false,
  },
  'chassis': {
    'data': [],
    'loading': false,
  },
};

const INITIAL_STATE = {
  'loading': false,
  'dataFloatingInventory': [],
  'dataFloatingClient': [],
  'currentScreen': 'FL_INV',
  'updateTable': false,
  'floatingClientList': floatingClientListInit,
  'floatingInventoryDropDownList': floatingInventoryDropDownListInit,
};

export const floatingInventoryAudit = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_FLOAT_INVENTORY_AUDIT]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT]: (state, action) => ({
      ...state,
      'loading': false,
      'dataFloatingInventory': action.response.data,
      'updateTable': !state.updateTable,
    }),
    [ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
   
    [ActionTypes.FETCHING_FLOAT_CLIENT_AUDIT]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT]: (state, action) => ({
      ...state,
      'loading': false,
      'dataFloatingClient': action.response.data,
      'updateTable': !state.updateTable,
    }),
    [ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CHANGE_CURRENT_SCREEN_FLOAT_AUDIT]: (state, action) => ({
      ...state,
      'currentScreen': action.payload,
    }),
    [ActionTypes.CLEAN_FLOATING_AUDIT_SCREEN]: (state, action) => ({
      ...state,
      'dataFloatingClient': [],
      'dataFloatingInventory': [],
      'floatingInventoryDropDownList': floatingInventoryDropDownListInit,
      'floatingClientList': floatingClientListInit,
      'updateTable': !state.updateTable,
    }),

    [ActionTypes.FETCHING_FLOAT_INVENTORY_AUDIT_LIST_ORDER]: (state) => ({
      ...state,
      'floatingInventoryDropDownList': {
        ...state.floatingInventoryDropDownList,
        'order': {
          ...state.floatingInventoryDropDownList.order,
          'loading': true,
        },
      },
    }),
    [ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_LIST_ORDER]: (state, action) => ({
      ...state,
      'loading': false,
      'floatingInventoryDropDownList': {
        ...state.floatingInventoryDropDownList,
        [action.response.prop]: {
          'data': action.response.data,
          'loading': false,
        },
      },
    }),
    [ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_LIST_ORDER_FAILED]: (state) => ({
      ...state,
      'floatingInventoryDropDownList': {
        ...state.floatingInventoryDropDownList,
        'order': {
          ...state.floatingInventoryDropDownList.order,
          'loading': false,
        },
      },
    }),

    [ActionTypes.FETCHING_FLOAT_INVENTORY_AUDIT_LIST_CHASSIS]: (state) => ({
      ...state,
      'floatingInventoryDropDownList': {
        ...state.floatingInventoryDropDownList,
        'chassis': {
          ...state.floatingInventoryDropDownList.chassis,
          'loading': true,
        },
      },
    }),
    [ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_LIST_CHASSIS]: (state, action) => ({
      ...state,
      'loading': false,
      'floatingInventoryDropDownList': {
        ...state.floatingInventoryDropDownList,
        [action.response.prop]: {
          'data': action.response.data,
          'loading': false,
        },
      },
    }),
    [ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_LIST_ORDER_CHASSIS]: (state) => ({
      ...state,
      'floatingInventoryDropDownList': {
        ...state.floatingInventoryDropDownList,
        'chassis': {
          ...state.floatingInventoryDropDownList.chassis,
          'loading': false,
        },
      },
    }),

    // Floating Client
    [ActionTypes.FETCHING_FLOAT_CLIENT_AUDIT_LIST_DOCUMENT]: (state) => ({
      ...state,
      'floatingClientList': {
        ...state.floatingClientList,
        'document': {
          ...state.floatingClientList.document,
          'loading': true,
        },
      },
    }),
    [ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_LIST_DOCUMENT]: (state, action) => ({
      ...state,
      'loading': false,
      'floatingClientList': {
        ...state.floatingClientList,
        [action.response.prop]: {
          'data': action.response.data,
          'loading': false,
        },
      },
    }),
    [ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_LIST_DOCUMENT_FAILED]: (state) => ({
      ...state,
      'floatingClientList': {
        ...state.floatingClientList,
        'document': {
          ...state.floatingClientList.document,
          'loading': false,
        },
      },
    }),

    [ActionTypes.FETCHING_FLOAT_CLIENT_AUDIT_LIST_NAMES]: (state) => ({
      ...state,
      'floatingClientList': {
        ...state.floatingClientList,
        'names': {
          ...state.floatingClientList.names,
          'loading': true,
        },
      },
    }),
    [ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_LIST_NAMES]: (state, action) => ({
      ...state,
      'loading': false,
      'floatingClientList': {
        ...state.floatingClientList,
        [action.response.prop]: {
          'data': action.response.data,
          'loading': false,
        },
      },
    }),
    [ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_LIST_NAMES_FAILED]: (state) => ({
      ...state,
      'floatingClientList': {
        ...state.floatingClientList,
        'names': {
          ...state.floatingClientList.names,
          'loading': false,
        },
      },
    }),

    [ActionTypes.FETCHING_FLOAT_CLIENT_AUDIT_LIST_LAST_NAMES]: (state) => ({
      ...state,
      'floatingClientList': {
        ...state.floatingClientList,
        'lastNames': {
          ...state.floatingClientList.lastNames,
          'loading': true,
        },
      },
    }),
    [ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_LIST_LAST_NAMES]: (state, action) => ({
      ...state,
      'loading': false,
      'floatingClientList': {
        ...state.floatingClientList,
        [action.response.prop]: {
          'data': action.response.data,
          'loading': false,
        },
      },
    }),
    [ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_LIST_LAST_NAMES_FAILED]: (state) => ({
      ...state,
      'floatingClientList': {
        ...state.floatingClientList,
        'lastNames': {
          ...state.floatingClientList.lastNames,
          'loading': false,
        },
      },
    }),

  })(state, action);
};
